import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { presentationPositionAtom, presentationViewChangedAtom, presentationZoomAtom, } from '@/store/boardAtoms';
/**
 * Хук для сброса состояния презентации
 *
 * @returns Функция для сброса состояния презентации к начальным значениям
 */
export const useResetPresentationState = () => {
    const [, setPresentationZoom] = useAtom(presentationZoomAtom);
    const [, setPresentationPosition] = useAtom(presentationPositionAtom);
    const [, setPresentationViewChanged] = useAtom(presentationViewChangedAtom);
    const resetPresentationState = useCallback(() => {
        setPresentationZoom(1);
        setPresentationPosition({ x: 0, y: 0 });
        setPresentationViewChanged(false);
    }, [setPresentationZoom, setPresentationPosition, setPresentationViewChanged]);
    return resetPresentationState;
};
